import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/icons/Menu";

export default function Navbar(props) {
  return (
    <Hidden mdUp>
      <IconButton
        // color="white"
        aria-label="open drawer"
        onClick={props.handleDrawerToggle}
      >
        <Menu style={{ color: "black", width: 40, height: 40 }} />
      </IconButton>
    </Hidden>
  );
}

Navbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
